"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _configuratorCarousel = _interopRequireDefault(require("../styles/configurator-carousel.css"));

var ProgressNumbers = function ProgressNumbers(_ref) {
  var visibleImageIndex = _ref.visibleImageIndex,
      carouselImagesLength = _ref.carouselImagesLength,
      theme = _ref.theme;
  var digitsToRoundTo = -2;

  var formatNumbers = function formatNumbers(number) {
    return ("0" + number).slice(digitsToRoundTo);
  };

  var currentNumber = formatNumbers(visibleImageIndex + 1);
  var maxNumber = formatNumbers(carouselImagesLength);
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.labelSmall + " " + _configuratorCarousel["default"].controlNumbers
  }, /*#__PURE__*/_react["default"].createElement("span", null, currentNumber), /*#__PURE__*/_react["default"].createElement("img", {
    src: "data:image/svg+xml,%3Csvg width='12' height='17' viewBox='0 0 12 17' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.384.639l1.732 1-8.5 14.722-1.732-1z' fill='%23000' fill-rule='evenodd'/%3E%3C/svg%3E",
    alt: "/",
    className: _configuratorCarousel["default"].controlsSlash
  }), /*#__PURE__*/_react["default"].createElement("span", null, maxNumber));
};

var _default = ProgressNumbers;
exports["default"] = _default;